/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-03 10:02:45
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\utils\routes.js
 */
import path from 'path'
import { isExternal, isString } from '@/utils/validate'
import { rolesControl } from '@/config'
import { hasRole } from '@/utils/hasRole'
/**
 * @description all模式渲染后端返回路由,支持包含views路径的所有页面
 * @param asyncRoutes
 * @returns {*}
 */
export function convertRouter(asyncRoutes) {
  return asyncRoutes.map((route) => {
    if (route.component && isString(route.component)) {
      if (route.component === 'Layout') {
        route.component = (resolve) => require(['@/common/layouts'], resolve)
      } else {
        const index = route.component.indexOf('views')
        const path = index > 0 ? route.component.slice(index) : `views/${route.component}`
        route.component = (resolve) => require([`@/${path}`], resolve)
      }
    }
    if (route.children && route.children.length) route.children = convertRouter(route.children)
    if (route.children && route.children.length === 0) delete route.children
    return route
  })
}
export const loadView = (view) => {
  return (resolve) => require([`@/views/${view}`], resolve)
}
/**
 * @description 根据roles数组拦截路由
 * @param routes 路由
 * @param rolesControl 是否进行权限控制
 * @param baseUrl 基础路由
 * @returns {[]}
 */
/*
export function filterRoutes(routes, baseUrl = '/') {
  return routes.map((route) => {
    if (route.path !== '*' && !isExternal(route.path)) route.path = path.resolve(baseUrl, route.path)
    if (route.children) route.children = filterRoutes(route.children, route.path)
    return route
  })
}
*/
export function filterRoutes(routes, baseUrl = '/') {
  return routes
    .filter((route) => {
      //如果路由定义了roles才进行权限判断，走hasrole函数，否则——直接返回true可以看见
      if (rolesControl && route.meta && route.meta.roles) {
        return hasRole(route.meta.roles)
      } else {
        return true
      }
    })
    .map((route) => {
      if (route.path !== '*' && !isExternal(route.path)) route.path = path.resolve(baseUrl, route.path)
      route.fullPath = route.path
      if (route.children) route.children = filterRoutes(route.children, route.fullPath)
      return route
    })
}
/*
export function filterRoutes(routes, baseUrl = '/') {
  let a = 'admin'
  return routes.map((route) => {
    // 

    if (route.path !== '*' && !isExternal(route.path)) {
      // 
      // if (route.meta  ) {
      //   if (route.meta.roles) {
      //     
      //   }
      // }
      if (route.meta && route.meta.roles) {
        
        route.path = path.resolve(baseUrl, route.path)
      }
    }
    if (route.children) {
      route.children = filterRoutes(route.children, route.path)
    }
    return route
  })
}
*/
